import { TbChartBar } from 'react-icons/tb';
import styles from './TestimonialCard.module.css';

/**
 * TestimonialCard — card de depoimento de cliente.
 *
 * @param {string} name - Nome do cliente
 * @param {string} segment - Segmento (ex: "Barbearia")
 * @param {string} text - Depoimento
 * @param {string} [metric] - Métrica de impacto (opcional)
 */
const TestimonialCard = ({ name, segment, text, metric }) => (
  <div className={styles.card}>
    {/* Aspas decorativas */}
    <div className={styles.quote} aria-hidden="true">
      &ldquo;
    </div>

    <p className={styles.text}>{text}</p>

    {metric && (
      <p className={styles.metric}>
        <TbChartBar aria-hidden="true" /> {metric}
      </p>
    )}

    <div>
      <strong className={styles.name}>{name}</strong>
      <span className={styles.segment}>• {segment}</span>
    </div>
  </div>
);

export default TestimonialCard;
